import { useState } from "react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { inputCls, btnPrimary } from "@/components/portal/PortalUI";

export const SetPasswordPrompt = ({ email }) => {
  const [pw, setPw] = useState("");
  const [done, setDone] = useState(false);
  if (done) return null;
  const save = async () => {
    try { await api.post("/student/auth/set-password", { email, password: pw }); toast.success("Password saved"); setDone(true); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="bg-magenta-light border border-magenta/30 rounded-lg p-4 mb-6 flex flex-wrap items-center gap-3" data-testid="set-password-prompt">
      <p className="text-sm text-navy font-semibold flex-1 min-w-[200px]">Finish registration: create a password so you can sign in with your email next time.</p>
      <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password (min 8)" className={`${inputCls} max-w-xs`} data-testid="prompt-password" />
      <button onClick={save} className={btnPrimary} data-testid="prompt-password-save">Save Password</button>
    </div>
  );
};
